var _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 13.5918L10.4766 11.9999",
    stroke: "#6D7D8B",
    strokeOpacity: 0.85,
    strokeWidth: 1.11436,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5996 13.5918L12.5996 11.9999",
    stroke: "#6D7D8B",
    strokeOpacity: 0.85,
    strokeWidth: 1.11436,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76172 9.34668H16.3133V9.34668C16.2148 9.34668 16.1655 9.34668 16.1239 9.34902C15.3689 9.39142 14.7661 9.99415 14.7237 10.7492C14.7214 10.7908 14.7214 10.8401 14.7214 10.9386V13.2735C14.7214 14.6743 14.7214 15.3747 14.2862 15.8099C13.851 16.2451 13.1506 16.2451 11.7498 16.2451H11.3253C9.92444 16.2451 9.22402 16.2451 8.78884 15.8099C8.35365 15.3747 8.35365 14.6743 8.35365 13.2735V10.9386C8.35365 10.8401 8.35365 10.7908 8.35132 10.7492C8.30892 9.99415 7.70618 9.39142 6.95116 9.34902C6.90954 9.34668 6.86026 9.34668 6.76172 9.34668V9.34668Z",
    stroke: "#6D7D8B",
    strokeOpacity: 0.85,
    strokeWidth: 1.11436,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5132 7.42028C10.5737 7.36387 10.7069 7.31402 10.8922 7.27846C11.0776 7.24291 11.3047 7.22363 11.5383 7.22363C11.7719 7.22363 11.999 7.24291 12.1844 7.27846C12.3697 7.31402 12.503 7.36387 12.5634 7.42028",
    stroke: "#6D7D8B",
    strokeOpacity: 0.85,
    strokeWidth: 1.11436,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5381,
    cy: 12,
    r: 11.0905,
    stroke: "#6D7D8B",
    strokeOpacity: 0.85,
    strokeWidth: 0.742903
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBin);
export default __webpack_public_path__ + "static/media/DeleteBin.88ddbda9.svg";
export { ForwardRef as ReactComponent };